import {Component, ElementRef, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CockpitCard} from 'shared/dtos/cockpit-card';
import {CockpitKontrolleM2} from 'shared/dtos/cockpit-kontrolle/cockpit-kontrolle';
import {
  AnzahlProKategorie,
  PruefungDerVariablenM2
} from 'shared/dtos/cockpit-kontrolle/pruefung-der-variablen';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {CockpitContentComponent} from '../../../cockpit-shared/cockpit-content-component';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';

@Component({
  selector: 'app-chart-dialog-pruefung-der-variablen-m2',
  templateUrl: './chart-dialog-pruefung-der-variablen-m2.component.html',
  styleUrl: './chart-dialog-pruefung-der-variablen-m2.component.scss',
  standalone: false
})
export class ChartDialogPruefungDerVariablenM2Component
  extends CurrentLocaleComponent
  implements OnInit, CockpitContentComponent
{
  cockpitKontrolle: CockpitKontrolleM2;
  pruefungDerVariablen: PruefungDerVariablenM2;
  effektiveAusbildung: AnzahlProKategorie[];
  card: CockpitCard;
  ausbildung: AnzahlProKategorie[];
  columns = [1, 2, 3, 4, 5];

  constructor(
    private readonly dataStorageService: DataStorageService,
    private readonly tableDataExport: TableExportService,
    protected readonly translate: TranslateService,
    private readonly element: ElementRef
  ) {
    super(translate);
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    this.cockpitKontrolle =
      (await this.dataStorageService.getCockpitKontrolle()) as CockpitKontrolleM2;
    this.pruefungDerVariablen = this.cockpitKontrolle?.pruefungDerVariablen;
    this.effektiveAusbildung =
      this.pruefungDerVariablen?.EffektiveAusbildung.reverse();
    this.ausbildung = this.pruefungDerVariablen?.Ausbildung.reverse();
  }

  constainsKategory(colIdx: number, arr: AnzahlProKategorie[]): boolean {
    return arr.some(p => p.Kategorie === (colIdx + 1).toString());
  }

  downloadTable() {
    this.tableDataExport.exportHtmlTableInElement(
      this.element.nativeElement,
      this.card.title,
      null,
      'pruefungDerVariablenVerteilungProVariableM2'
    );
  }

  downloadTable2() {
    this.tableDataExport.exportHtmlTableInElement(
      this.element.nativeElement,
      this.card.title,
      null,
      'pruefungDerVariablenVerteilungProVariable2M2'
    );
  }
}
